'use strict'

module.exports =
  initialize: (@storageId) ->
    @addDealClickHandler()
    @relatedDealStorageId = 'desktop:relatedDealIds'

  scrollToLastClickedDeal: ->
    dealId = window.sessionStorage.getItem(@storageId)
    if dealId
      document.querySelector(".cui-c-deal[data-bhc='" + dealId + "']")?.scrollIntoView()

  getLastDealId: ->
    return window.sessionStorage.getItem(@storageId)

  addDealClickHandler: ->
    storageId = @storageId
    for el in document.querySelectorAll('#pull-cards figure.cui-c-udc')
      el.addEventListener 'mousedown', @_mouseDownEvent(storageId)

  _mouseDownEvent: (storageId) ->
    (event) ->
      dealId = event.currentTarget?.getAttribute("data-bhc")
      window.sessionStorage.setItem(storageId, dealId)

  getRelatedDealIds: ->
    return JSON.parse(window.sessionStorage.getItem(@relatedDealStorageId))

  addRelatedDealIds: (relatedDealIds) ->
    window.sessionStorage.setItem(@relatedDealStorageId, JSON.stringify(relatedDealIds))

  clearRelatedDealIds: ->
    window.sessionStorage.removeItem(@relatedDealStorageId)
